/* tslint:disable */
/* eslint-disable */
/**
 * acomo API docs
 * acomoのAPI仕様書です。
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ModelWithNodeActionsEntity,
  ProcessWithNodeActionsEntity,
  SystemActionPoliciesEntity,
} from '../models/index';
import {
    ModelWithNodeActionsEntityFromJSON,
    ModelWithNodeActionsEntityToJSON,
    ProcessWithNodeActionsEntityFromJSON,
    ProcessWithNodeActionsEntityToJSON,
    SystemActionPoliciesEntityFromJSON,
    SystemActionPoliciesEntityToJSON,
} from '../models/index';

export interface ListSystemActionPoliciesRequest {
    userId: string;
}

export interface ListUserModelWithNodeActionsRequest {
    userId: string;
    nodeActionType: ListUserModelWithNodeActionsNodeActionTypeEnum;
    filter?: string;
    skip?: string;
    take?: string;
}

export interface ListUserProcessWithNodeActionsRequest {
    userId: string;
    nodeActionType: ListUserProcessWithNodeActionsNodeActionTypeEnum;
    filter?: string;
    skip?: string;
    take?: string;
}

/**
 * 
 */
export class ActionApi extends runtime.BaseAPI {

    /**
     * ユーザーが持つシステム実行ポリシーを一覧で取得する。
     */
    async listSystemActionPoliciesRaw(requestParameters: ListSystemActionPoliciesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<SystemActionPoliciesEntity>>> {
        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling listSystemActionPolicies().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['userId'] != null) {
            queryParameters['userId'] = requestParameters['userId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-tenant-id"] = await this.configuration.apiKey("x-tenant-id"); // Tenant authentication
        }

        const response = await this.request({
            path: `/api/v1/actions/systemActionPolicies`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(SystemActionPoliciesEntityFromJSON));
    }

    /**
     * ユーザーが持つシステム実行ポリシーを一覧で取得する。
     */
    async listSystemActionPolicies(requestParameters: ListSystemActionPoliciesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<SystemActionPoliciesEntity>> {
        const response = await this.listSystemActionPoliciesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * ユーザーが権限を持つモデルの一覧をアクション可能なノードとアクションと併せて取得する。
     */
    async listUserModelWithNodeActionsRaw(requestParameters: ListUserModelWithNodeActionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ModelWithNodeActionsEntity>>> {
        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling listUserModelWithNodeActions().'
            );
        }

        if (requestParameters['nodeActionType'] == null) {
            throw new runtime.RequiredError(
                'nodeActionType',
                'Required parameter "nodeActionType" was null or undefined when calling listUserModelWithNodeActions().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['userId'] != null) {
            queryParameters['userId'] = requestParameters['userId'];
        }

        if (requestParameters['nodeActionType'] != null) {
            queryParameters['nodeActionType'] = requestParameters['nodeActionType'];
        }

        if (requestParameters['filter'] != null) {
            queryParameters['filter'] = requestParameters['filter'];
        }

        if (requestParameters['skip'] != null) {
            queryParameters['skip'] = requestParameters['skip'];
        }

        if (requestParameters['take'] != null) {
            queryParameters['take'] = requestParameters['take'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-tenant-id"] = await this.configuration.apiKey("x-tenant-id"); // Tenant authentication
        }

        const response = await this.request({
            path: `/api/v1/actions/models`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ModelWithNodeActionsEntityFromJSON));
    }

    /**
     * ユーザーが権限を持つモデルの一覧をアクション可能なノードとアクションと併せて取得する。
     */
    async listUserModelWithNodeActions(requestParameters: ListUserModelWithNodeActionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ModelWithNodeActionsEntity>> {
        const response = await this.listUserModelWithNodeActionsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 権限を持つプロセスの一覧をアクション可能なノードとアクションと併せて取得する。
     */
    async listUserProcessWithNodeActionsRaw(requestParameters: ListUserProcessWithNodeActionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ProcessWithNodeActionsEntity>>> {
        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling listUserProcessWithNodeActions().'
            );
        }

        if (requestParameters['nodeActionType'] == null) {
            throw new runtime.RequiredError(
                'nodeActionType',
                'Required parameter "nodeActionType" was null or undefined when calling listUserProcessWithNodeActions().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['userId'] != null) {
            queryParameters['userId'] = requestParameters['userId'];
        }

        if (requestParameters['nodeActionType'] != null) {
            queryParameters['nodeActionType'] = requestParameters['nodeActionType'];
        }

        if (requestParameters['filter'] != null) {
            queryParameters['filter'] = requestParameters['filter'];
        }

        if (requestParameters['skip'] != null) {
            queryParameters['skip'] = requestParameters['skip'];
        }

        if (requestParameters['take'] != null) {
            queryParameters['take'] = requestParameters['take'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-tenant-id"] = await this.configuration.apiKey("x-tenant-id"); // Tenant authentication
        }

        const response = await this.request({
            path: `/api/v1/actions/processes`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ProcessWithNodeActionsEntityFromJSON));
    }

    /**
     * 権限を持つプロセスの一覧をアクション可能なノードとアクションと併せて取得する。
     */
    async listUserProcessWithNodeActions(requestParameters: ListUserProcessWithNodeActionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ProcessWithNodeActionsEntity>> {
        const response = await this.listUserProcessWithNodeActionsRaw(requestParameters, initOverrides);
        return await response.value();
    }

}

/**
 * @export
 */
export const ListUserModelWithNodeActionsNodeActionTypeEnum = {
    Manage: 'manage',
    Read: 'read',
    Start: 'start',
    Submit: 'submit',
    Approve: 'approve',
    Reject: 'reject',
    Revert: 'revert',
    Update: 'update'
} as const;
export type ListUserModelWithNodeActionsNodeActionTypeEnum = typeof ListUserModelWithNodeActionsNodeActionTypeEnum[keyof typeof ListUserModelWithNodeActionsNodeActionTypeEnum];
/**
 * @export
 */
export const ListUserProcessWithNodeActionsNodeActionTypeEnum = {
    Manage: 'manage',
    Read: 'read',
    Start: 'start',
    Submit: 'submit',
    Approve: 'approve',
    Reject: 'reject',
    Revert: 'revert',
    Update: 'update'
} as const;
export type ListUserProcessWithNodeActionsNodeActionTypeEnum = typeof ListUserProcessWithNodeActionsNodeActionTypeEnum[keyof typeof ListUserProcessWithNodeActionsNodeActionTypeEnum];
